<template>
  <div class="category-page-tile"
    ref="tileContent"
  >
    <router-link
      :to="routerLinkTo"
      v-touch="touchHandler"
    >
      <div class="info-container"
        :class="containerClasses"
      >
        <div class="background" />
        <div class="info-content">
          <div class="subhead">
            our work and thoughts on:
          </div>
          <div class="headline"
            ref="headlineContent"
            >
           {{record.headline}}
          </div>
          <div class="ornament" />
          <div class="arrow" />
          <div class="corner upper-left" />
          <div class="corner lower-right" />
        </div>

      </div>
    </router-link>
  </div>
</template>

<script>
/*
  this component fits to the size of its container
  width: 100%; height: 100%;
  so container must define size and location
*/
// Libs
import Vue from 'vue';

import { Bus } from '@/helpers/bus';
import { Events } from '@/app-constants';

import WorkMixin from '../../modules/work/WorkMixin';

export default {

  name: 'category-page-tile',

  mixins: [WorkMixin],

  props: ['record'],

  data() {
    return {
      isTapped: false,
      handleBusTapEventFunc: null,
      headlineContentHeight: 0,
      tileContentHeight: 0,
    };
  },

  computed: {

    containerClasses() {
      const { isMobile, isTablet } = this;
      // return class string, eg 'desktop', 'mobile'
      let deviceStr = '';
      if (isMobile) {
        deviceStr = 'mobile';
      } else if (isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return deviceStr;
    },


    routerLinkTo() {
      const { url, data } = this.record;
      return {
        path: url,
        params: {
          url: url,
          data,
        },
      };
    },

    currentBrowserWidth() {
      return this.$store.state.width;
    },

  },

  methods: {

    // called from parent
    calculateTileAdjustment() {
      this.measureLayout();
      const { isDesktop, isTablet, headlineContentHeight } = this;
      const lineHeight = 60; // account for 1 line

      let realHeight = headlineContentHeight;
      // adjust with margin from below
      if (isDesktop) {
        realHeight -= 22;
      } else if (isTablet) {
        realHeight -= 12;
      } else {
        realHeight -= 24;
      }

      const diff = realHeight - lineHeight;
      const ff = 5; // 5 used as fudge factor
      return (diff > -ff && diff < ff) ? 0 : 40;
    },

    getHeadlineContentHeight() {
      const el = this.$refs.headlineContent;
      return (el) ? el.clientHeight : 0;
    },

    getTileContentHeight() {
      const el = this.$refs.tileContent;
      return (el) ? el.clientHeight : 0;
    },

    measureLayout() {
      this.headlineContentHeight = this.getHeadlineContentHeight();
      this.tileContentHeight = this.getTileContentHeight();
    },

    touchHandler() {
      const { slug } = this.record;
      Bus.$emit(Events.TappedArticle, slug);
    },

  },

  watch: {

    currentBrowserWidth(/* newVal, oldVal */) {
      Vue.nextTick(() => {
        this.measureLayout();
      });
    },

  },

  mounted() {
    this.measureLayout();
  },

};
</script>


<style lang="scss" scoped>
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';
@import '~@/styles/_variables.scss';

.category-page-tile {
  width: 100%;
  height: 100%;

  align-self: flex-start;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  // media query props
  padding: 10px;

  @include ngMq($nbp--tablet, up) {
    padding: 0;
  }

  > a {
    display: block;
    color: $color--primary-dark;

    width: 100%;
    height: 100%;
    text-decoration: none;
  }

  // for the main container, no content
  .info-container {

    .background {
      position: absolute;
      background: rgba(white, $tile--default-opacity);

      // media query props
      width: calc(100% - 2px);
      height: calc(100% - 4px);
      margin: 2px;
    }

    .info-content {

      // center the content
      // top: 50%;
      // transform: translateY(-50%);
      height: 100%;

      .subhead {
        text-transform: uppercase;
        @include sansserif( $size: (14, 14, -0.5) );
        margin-left: rem(30px);

        // media query props
        padding-top: rem(84px);

        @include ngMq($nbp--tablet, up) {
          padding-top: rem(44px);
        }
        @include ngMq($nbp--desktop, up) {
          padding-top: rem(56px);
        }
      }

      .headline {
        color: black;
        @include serif( $size: (49, 60, -0.1) );
        margin-left: rem(30px);
        hyphens: manual;

        // media query props
        padding-top: rem(32px);
        margin-right: rem(30px);
        
        @include ngMq($nbp--tablet, up) {
          margin-right: rem(90px);
          padding-top: rem(12px);
        }
        @include ngMq($nbp--desktop, up) {
          margin-right: rem(90px);
          padding-top: rem(22px);
        }
      }

      .ornament {
        position: absolute;
        width: rem(184px);
        padding-top: rem(184px); // 1:1
        background-color: $color--primary-highlight;
        opacity: 0.3;

        -webkit-mask: url('~@/assets/ornaments/circle.svg') no-repeat 50% 50%;
        mask: url('~@/assets/ornaments/circle.svg') no-repeat 50% 50%;
        mask-size: contain;

        right: rem(170px - (184px / 2));
        top: calc(50% - (184px / 2)); // h center

        @include ngMq($nbp--tablet, up) {
        }
        @include ngMq($nbp--desktop, up) {
        }
      }

      .arrow {
        position: absolute;
        height: 32px;
        width: 32px;
        background-color: $color--primary-highlight;
        opacity: 1;

        -webkit-mask: url('~@/assets/ornaments/arrow-in-circle.svg') no-repeat 50% 50%;
        mask: url('~@/assets/ornaments/arrow-in-circle.svg') no-repeat 50% 50%;
        mask-size: contain;

        // media query props
        right: 22px;
        bottom: 36px;

        @include ngMq($nbp--tablet, up) {
          right: 40px;
          bottom: 30px;
        }
        @include ngMq($nbp--desktop, up) {
          right: 40px;
          bottom: 40px;
        }
      }
      .corner {
        position: absolute;
        height: 30px;
        width: 30px;
        background-color: $color--primary-highlight;
        opacity: 1;

        -webkit-mask: url('~@/assets/ornaments/corner-bracket.svg') no-repeat 50% 50%;
        mask: url('~@/assets/ornaments/corner-bracket.svg') no-repeat 50% 50%;
        mask-size: contain;
      }
      .corner.upper-left {
        top: 0;
        left: 0;
        transform: rotate(180deg);
      }
      .corner.lower-right {
        bottom: 0;
        right: 0;
      }
    }
  }

  .info-container.mobile {
    width: 100%;
    height: 100%;
    margin: 0;
  }
  .info-container.tablet {
    width: 100%;
    height: 100%;
    margin: 0;
  }
  .info-container.desktop {
    height: 100%;
    margin: 0 (($grid-gap-desktop + $grid-column-desktop) * 1px);
  }

  // animations
  .info-container {
    transition: all 250ms;

    .subhead {
      transition: all 250ms;
    }
    .headline {
      transition: all 250ms;
    }
    .ornament {
      transition: all 250ms;
    }
    .arrow {
      transition: all 250ms;
    }

    &:hover,
    &:active,
    &:focus,
    &.tapped {
      transform: scale(1.0125);
      box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.5);

      .subhead {
        transform: scale(1.0125);
      }
      .headline {
        transform: scale(1.0125);
      }
      .ornament {
        transform: translateX(-60px);
        transform: scale(0.90);
      }
      .arrow {
        transform: translateX(15px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/article-tile/CategoryPageTile.vue